module.exports = __webpack_public_path__ + "static/media/MattWestoverResume.954a4154.pdf";